import { formatDateAndTimeZ } from 'lib/helpers/utility';

export const getColDefs = (timezone) => [
  {
    field: 'lab_name',
    headerName: 'Lab',
    flex: 1
  },
  {
    field: 'report_status',
    headerName: 'Status',
    flex: 1
  },
  {
    field: 'created_at',
    headerName: 'Result Date',
    valueGetter: ({ data }) =>
      data?.created_at ? formatDateAndTimeZ(data?.created_at, timezone) : '-',
    flex: 2
  }
];
